import React from 'react';

const Question1 = ({ setQuestionResponse, response, question, handleResponse }) => {

  const handleChange = (event) => {
    const value = event.target.value === 'true';
    handleResponse(0, value);
    setQuestionResponse([value, null, null, null, null, null]);
  };

  const renderMessageBox = () => {
    if (response === false) {
      return (
        <div className="message-box">
          <div>
            <i className="fas fa-info-circle blue"></i>
          </div>
          <div dangerouslySetInnerHTML={{__html: question.message_html}} />
        </div>
      );
    }
    return null;
  };

  const renderHumanSubjectRadioButtons = () => {
    return (
      <div>
        <h5>{question.question_text}</h5>
        <input type="radio" name="human_subjects" value="true" onChange={handleChange} checked={response === true} id="human_subjects_true"/>
        <label htmlFor="human_subjects_true">{question.true_response_text}</label>
        <br />
        <input type="radio" name="human_subjects" value="false" onChange={handleChange} checked={response === false} id="human_subjects_false"/>
        <label htmlFor="human_subjects_false">{question.false_response_text}</label>
        <br />
        {renderMessageBox()}
      </div>
    );
  };

  return (
    <div>
      {renderHumanSubjectRadioButtons()}
    </div>
  );
};

export default Question1;